import React, { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const CashIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#clip0_2923_5548)">
      <path
        d="M5.92474 10.7893C5.92474 13.3969 3.81091 15.5107 1.20337 15.5107"
        stroke="#00619E"
        strokeWidth="2"
      />
      <path
        d="M6.03021 23.4655C6.03021 20.858 3.91638 18.7441 1.30884 18.7441"
        stroke="#00619E"
        strokeWidth="2"
      />
      <path
        d="M22.3387 19.1425C22.3387 16.535 24.4526 14.4211 27.0601 14.4211"
        stroke="#00619E"
        strokeWidth="2"
      />
      <path
        d="M26.9547 11.231C24.3471 11.231 22.2333 9.11719 22.2333 6.50964"
        stroke="#00619E"
        strokeWidth="2"
      />
      <path
        d="M10.4198 19.5694C9.50285 18.9066 8.79187 17.8027 8.79187 16.0312C8.79187 14.2153 9.43177 12.7288 10.3636 12.0052"
        stroke="#00AED9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8571 10.1734C18.774 10.8362 19.485 11.9401 19.485 13.7115C19.485 15.5275 18.8451 17.014 17.9132 17.7376"
        stroke="#00AED9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1115 17.3555C12.0413 17.2861 11.8868 17.0082 12.1115 16.6193C12.3362 16.2303 12.6662 16.3206 12.7504 16.3831C12.9891 16.5429 13.4174 16.8415 13.944 16.8415C14.281 16.8415 14.5267 16.6332 14.5267 16.3414C14.5267 15.9941 14.2178 15.7649 13.6561 15.501C12.8487 15.1051 12.0272 14.6605 12.0272 13.6603C12.0272 12.8338 12.6802 12.0002 13.9721 12.0002C14.8497 12.0002 15.5237 12.4448 15.7765 12.6254C15.8748 12.6809 15.8116 13.0699 15.6571 13.2783C15.5027 13.4867 15.1937 13.6881 15.0252 13.5909C14.8357 13.4589 14.3372 13.1394 13.8878 13.1394C13.5368 13.1394 13.3753 13.3547 13.3753 13.5978C13.3753 13.8756 13.7053 14.091 14.295 14.3757C15.0393 14.7369 15.9941 15.1398 15.9941 16.272C15.9941 17.1333 15.2429 17.9945 14.0072 17.9945C12.9119 18.0015 12.3081 17.55 12.1115 17.3555Z"
        fill="#00AED9"
      />
      <rect
        x="13.4978"
        y="11"
        width="0.998745"
        height="2.00042"
        rx="0.499373"
        fill="#00AED9"
      />
      <rect
        x="13.4978"
        y="17.0015"
        width="0.998745"
        height="2.00042"
        rx="0.499373"
        fill="#00AED9"
      />
      <path
        d="M19.414 19.9855L19.6283 20.9623L19.414 19.9855C19.3285 20.0043 19.2486 20.0245 19.1688 20.0465C18.1597 20.3259 9.91869 22.5981 7.11571 23.0991C4.05359 23.6464 2.0496 23.7443 1 23.7435V10.7993C1 10.7976 1.00015 10.7973 1.00024 10.7972C1.00025 10.7971 1.00026 10.7971 1.00027 10.7971C1.00061 10.7963 1.00188 10.7937 1.00504 10.7904C1.00823 10.7871 1.01209 10.7843 1.01598 10.7825C1.01937 10.7809 1.02327 10.7798 1.02874 10.7794C2.58916 10.6909 5.79078 10.44 8.94803 9.76543C11.5979 9.19923 13.9672 8.5354 16.0346 7.95195L16.1848 7.90956C18.2048 7.33942 19.8946 6.86246 21.3187 6.60965C24.3211 6.07664 26.2558 5.99152 27.2699 6.00062V19.0069L27.2698 19.0085L27.2697 19.009L27.2697 19.0092C27.2695 19.0095 27.2688 19.011 27.267 19.013C27.2651 19.015 27.2631 19.0164 27.2613 19.0172C27.2601 19.0178 27.2582 19.0185 27.2543 19.0188C25.5985 19.1262 22.0507 19.4071 19.414 19.9855Z"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M4 26.4999C3.99997 26.9999 3.99997 27.4999 4.00003 27.4812C4 27.4999 6.99637 27.5506 10.9793 26.8387C13.7048 26.3516 21.6007 24.1739 22.5632 23.9074C22.628 23.8895 22.6916 23.8734 22.7572 23.859C25.1731 23.3296 28.4531 23.0648 30.049 22.9604C30.5822 22.9255 30.9998 22.4846 30.9998 21.9504V10.0002C30.9998 9.44793 31.053 9.00007 30.5007 8.99997C30.3596 8.99994 30.1939 8.99991 30 8.99988"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2923_5548">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

export default CashIcon;
